export default {"src":"/login-app/[GIT_HASH]/_next/static/media/key_return.d140979e.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};